import Axios from "axios";
import {
  SET_EDITING_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST,
  SET_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST,
  UNSET_EDITING_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST,
  UNSET_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST,
} from "@/store/mutation-types";
import { 
  getHrmEmployeeKpiAssignmentsList,
  saveHrmEmployeeKpiAssignment,
  getHrmEmployeeKpiAssignmentById
} from "@/store/api";

const state = {
  getHrmEmployeeKpiAssignmentsList: [],
  getEditingHrmEmployeeKpiAssignment: null,
};

const getters = {
  getHrmEmployeeKpiAssignmentsList(state) {
    return state.getHrmEmployeeKpiAssignmentsList;
  },
  getEditingHrmEmployeeKpiAssignment(state) {
    return state.getEditingHrmEmployeeKpiAssignment;
  },
};

const mutations = {
  [SET_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST](state, data) {
    state.getHrmEmployeeKpiAssignmentsList = data;
  },
  [UNSET_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST](state) {
    state.getHrmEmployeeKpiAssignmentsList = [];
  },
  [SET_EDITING_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST](state, data) {
    state.getEditingHrmEmployeeKpiAssignment = data;
  },
  [UNSET_EDITING_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST](state) {
    state.getEditingHrmEmployeeKpiAssignment = [];
  },
};

const actions = {

  saveHrmEmployeeKpiAssignment({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveHrmEmployeeKpiAssignment, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getHrmEmployeeKpiAssignmentsList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeeKpiAssignmentsList, {params:data})
        .then(function (response) {
          commit('SET_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST', response.data.data)
          resolve(response.data.data);
        })
        .catch(function (error) {
          commit('UNSET_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getHrmEmployeeKpiAssignmentById({ commit }, data) {
    const getInvCustomerKpi = `${getHrmEmployeeKpiAssignmentById}/${data}`;
    commit("SET_LOADING", {color: "primary"});  
    return new Promise((resolve, reject) => {
      Axios.get(getInvCustomerKpi)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};  

export default {
  state,
  getters,
  actions,
  mutations,
};
